import _ from "lodash";

export const findIndexPermission = (permissions, module) => {
  return _.findIndex(permissions, function (p) {
    return p.permission === module;
  });
};

export const hasAnyPermission = (permissions, module) => {
  return (
    permissions &&
    permissions.some((p) => {
      return module === p.permission;
    })
  );
};
